<template>
  <div class="container" :style="{ height: windowHeight + 'px' }">
    <van-nav-bar
      title="物流信息"
      left-text=""
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    />

    <van-steps :active="active">
      <van-step>客户下单</van-step>
      <van-step>商家发货</van-step>
      <van-step>客户收货</van-step>
      <van-step>交易完成</van-step>
    </van-steps>

    <van-steps direction="vertical" :active="0" class="logisticsBox">
      <van-step>
        <h4>【城市】物流状态1</h4>
        <p>2016-07-12 12:40</p>
      </van-step>
      <van-step>
        <h4>【城市】物流状态2</h4>
        <p>2016-07-11 10:00</p>
      </van-step>
      <van-step>
        <h4>快件已发货</h4>
        <p>2016-07-10 09:30</p>
      </van-step>
    </van-steps>
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      active: 1, //steps激活下标
    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    onClickLeft() {
      this.$router.replace({
        path: "/orderDetails",
        query: { voucherCode: this.$route.query.voucherCode },
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.container {
  width: 100%;
  background-color: rgba(247, 243, 249, 1);
  text-align: initial;
  .logisticsBox{
      margin:20px 0 0 0;
      h4,p{
          margin: 0;
      }
  }
}
</style>